export default __webpack_public_path__ + "static/media/preguntasFrecuentes.45969ae0.svg";